<template>
  <div class="relative flex items-center justify-center flex-col px-8 py-8 md:min-h-[380px] mb-12">
    <picture>
      <source media="(min-width: 768px)" :srcset="bgImage" />
      <source media="(max-width: 767px)" :srcset="bgImageMobile" />

      <img :src="bgImage" alt="LayUp Banner" class="absolute inset-0 w-full h-full object-cover rounded-4xl" />
    </picture>
    <div :class="['flex flex-col items-center justify-center z-10 text-white py-12 md:py-0', themeStore.current === 'boost'? 'max-w-2xl' : 'max-w-md']">
      <img v-if="props.image" :src="image" alt="Shop Now Image" class="relative md:hidden self-end -mt-4 w-10/12 mb-4" />
      <h2 class="text-[40px] font-extrabold leading-tight mb-4 md:mb-5 text-center">{{ props.title }}</h2>
      <p class="text-lg md:text-xl italic mb-8 text-center">{{ props.description }}</p>
      <router-link :to="{ name: `${themeStore.current}-stores` }">
        <Button size="lg" class="py-6 cursor-pointer bg-brand-secondary hover:bg-brand-secondary/90 text-white">
          Shop Now
        </Button>
      </router-link>
    </div>
  </div>
  <hr class="hidden md:block" />
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button';
import { useThemeStore } from '@/stores/theme';
import { computed } from 'vue';

const themeStore = useThemeStore();

interface Props {
  title: string;
  description: string;
  backgroundImage: string;
  backgroundImageMobile: string;
  image: string;
}

const props = withDefaults(defineProps<Props>(), {
  title: 'Payments made simple, for you.',
  description: 'Sign up for free or visit our stores to start shopping today.',
  backgroundImage: 'layby-ad-banner-background.webp',
  backgroundImageMobile: 'layby-ad-banner-background-mobile.webp',
  image: '',
});

const bgImage = computed(() =>
  props.backgroundImage ? new URL(`../../assets/images/${props.backgroundImage}`, import.meta.url).href : '',
);

const bgImageMobile = computed(() =>
  props.backgroundImageMobile
    ? new URL(`../../assets/images/${props.backgroundImageMobile}`, import.meta.url).href
    : '',
);
</script>
